var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center mb-5"},[_c('a',{staticClass:"btn btn-xl btn-outline-secondary my-3 py-3",on:{"click":_vm.windowClose}},[_c('i',{staticClass:"fas fa-times mr-2"}),_vm._v(" Sluit deze pagina ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }